import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios';
import './dash.css'
import Sidebar from './Sidebar';
import MetaData from '../layouts/MetaData';

const S3ImageGallery = () => {

    const [images, setImages] = useState([]);
    const [selectedImages, setSelectedImages] = useState([]);

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchImages = async () => {
        try {
            const res = await axios.get('/api/v1/get-images');
            setImages(res.data.images);
        } catch (error) {
            console.error('Failed to fetch images', error);
        }
    };

    // ✅ select checkbox
    const handleSelect = (key) => {
        setSelectedImages(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    };

    // ✅ single delete (your same logic)
    const deleteImage = async (key) => {
        if (!window.confirm('Are you sure you want to delete this image?')) return;

        try {
            await axios.delete(`/api/v1/deleteawsimages`, { data: { key } });
            setImages(images.filter(img => !img.includes(key)));
            setSelectedImages(prev => prev.filter(k => k !== key));
        } catch (error) {
            console.error('Failed to delete image', error);
        }
    };

    // ✅ bulk delete
    const deleteSelectedImages = async () => {
        if (selectedImages.length === 0) return alert("No images selected");

        if (!window.confirm('Delete selected images?')) return;

        try {
            await Promise.all(
                selectedImages.map(key =>
                    axios.delete(`/api/v1/deleteawsimages`, { data: { key } })
                )
            );

            setImages(images.filter(img =>
                !selectedImages.some(key => img.includes(key))
            ));

            setSelectedImages([]);

        } catch (error) {
            console.error('Bulk delete failed', error);
        }
    };

    return (
      <Fragment>
        <MetaData title="Admin S3 Image Gallery | GLCORE private limited" />

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2 d-none d-md-block">
              <Sidebar />
            </div>

            <div className="col-12 col-md-10">
              {/* ✅ BULK DELETE BUTTON */}
              {selectedImages.length > 0 && (
                <button
                  className="btn btn-danger mb-3"
                  onClick={deleteSelectedImages}
                  style={{ position: 'sticky', top: '10px', zIndex: '100' }}
                >
                  Delete Selected ({selectedImages.length})
                </button>
              )}

              <div className="image-gallery">
                {images?.map(url => {
                  const key = url.split('/').slice(3).join('/');
                  const isChecked = selectedImages.includes(key);

                  return (
                    <div key={url} className="image-card">
                      {/* ✅ CHECKBOX */}
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleSelect(key)}
                        className="image-checkbox"
                      />

                      <img src={url} alt="S3 file" />

                      {/* ✅ YOUR EXISTING DELETE BUTTON */}
                      <button
                        onClick={() => deleteImage(key)}
                        className="delete-btn"
                        title="Delete"
                      >
                        ×
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
};

export default S3ImageGallery;